<ng-container *ngIf="!isAutolog">
    <div
        *ngIf="!this.invitation || !this.invitation.status"
        [class.signup-landing__buttons--with-padding]="!removeSidePaddings"
        class="block-buttons signup-landing__buttons"
    >
        <button (click)="createAccount()" class="mat-elevation-z" color="primary" mat-flat-button>
            {{ 'Creer mon compte' | transloco }}
        </button>
        <div (click)="changeAccount()" class="link custom-link blue" data-testid="btn-have-an-account">
            {{ "J'ai deja un compte" | transloco }}
        </div>
    </div>
    <div
        *ngIf="checkService.isConnected() && invitation && invitation.status"
        [ngSwitch]="invitation.status"
        class="block-buttons signup-landing__buttons"
    >
        <!-- Pending -->
        <ng-container *ngSwitchCase="'pending'">
            <div
                *ngIf="acceptIsPasswordRestricted"
                [position]="'above'"
                [signupTooltip]="'Vous devez definir un mot de passe pour accepter l\'invitation.' | transloco"
                class="input-accept-with-tooltip"
            >
                <button [disabled]="acceptIsPasswordRestricted" class="mat-elevation-z" color="primary" mat-flat-button>
                    {{ "Accepter l'invitation" | transloco }}
                </button>
            </div>
            <button
                (click)="login()"
                *ngIf="!acceptIsPasswordRestricted && !checkService.isKsuiteUserMailbox()"
                [buttonLoader]="isLoading"
                class="mat-elevation-z"
                color="primary"
                mat-flat-button
            >
                {{ "Accepter l'invitation" | transloco }}
            </button>
            <button
                (click)="login()"
                *ngIf="!acceptIsPasswordRestricted && checkService.isKsuiteUserMailbox()"
                [buttonLoader]="isLoading"
                class="mat-elevation-z"
                color="primary"
                mat-flat-button
            >
                {{ 'Valider et acceder a kMail' | transloco }}
            </button>
            <div
                (click)="changeAccount()"
                *ngIf="!userIsMatching() && isOtherAccountButtonDisplayed()"
                class="link custom-link blue"
            >
                {{ 'Utiliser un autre compte' | transloco }}
            </div>
        </ng-container>
        <!-- Pending Auth -->
        <ng-container *ngSwitchCase="'pending_auth'">
            <button (click)="changeAccount()" class="mat-elevation-z" color="primary" mat-flat-button>
                {{ 'Utiliser un autre compte' | transloco }}
            </button>
        </ng-container>
        <!-- Pending Create -->
        <ng-container *ngSwitchCase="'pending_create'">
            <button (click)="logout()" class="mat-elevation-z" color="primary" mat-flat-button>
                {{ 'Creer mon compte' | transloco }}
            </button>
        </ng-container>
        <!-- Already in kSuite -->
        <ng-container *ngSwitchCase="'user_already_in_ksuite'">
            <button (click)="logout()" class="mat-elevation-z" color="primary" mat-flat-button>
                {{ "Creer mon compte et accepter l'invitation" | transloco }}
            </button>
            <div (click)="changeAccount()" class="link custom-link blue">
                {{ 'Utiliser un autre compte' | transloco }}
            </div>
        </ng-container>
    </div>
    <div
        *ngIf="!checkService.isConnected() && invitation && invitation.status"
        [ngSwitch]="invitation.status"
        class="block-buttons signup-landing__buttons"
    >
        <!-- Pending -->
        <ng-container *ngSwitchCase="'pending'">
            <button (click)="createAccount()" class="mat-elevation-z" color="primary" mat-flat-button>
                {{ 'Creer mon compte' | transloco }}
            </button>
            <div
                (click)="changeAccount()"
                *ngIf="isOtherAccountButtonDisplayed()"
                class="link custom-link blue"
                data-testid="btn-have-an-account"
            >
                {{ "J'ai deja un compte" | transloco }}
            </div>
        </ng-container>
        <!-- Pending Auth -->
        <ng-container *ngSwitchCase="'pending_auth'">
            <button (click)="changeAccount()" class="mat-elevation-z" color="primary" mat-flat-button>
                {{ "ACCEPTER L'INVITATION" | transloco }}
            </button>
        </ng-container>
        <!-- Pending Create -->
        <ng-container *ngSwitchCase="'pending_create'">
            <button (click)="createAccount()" class="mat-elevation-z" color="primary" mat-flat-button>
                {{ 'Creer mon compte' | transloco }}
            </button>
        </ng-container>
    </div>
</ng-container>

<ng-container *ngIf="isAutolog">
    <div
        [position]="'above'"
        [signupTooltip]="'Vous ne pouvez pas accepter une invitation en etant autolog.' | transloco"
        class="block-buttons signup-landing__buttons custom-solo-autolog-button"
    >
        <button [disabled]="true" class="mat-elevation-z" color="primary" mat-flat-button>
            {{ "Accepter l'invitation" | transloco }}
        </button>
    </div>
</ng-container>
